export default __webpack_public_path__ + "b1b04b2c76957c6c1ee14e1abd11721e.png";